import {
  FaCalendarAlt,
  FaCalculator,
  FaChartBar,
  FaChartLine,
  FaChartPie,
  FaClipboardList,
  FaExchangeAlt,
  FaFilter,
  FaHandHoldingUsd,
  FaHistory,
  FaHome,
  FaMoneyBillAlt,
  FaMoneyBillWave,
  FaBoxOpen,
  FaUserPlus,
  FaUserShield,
  FaUserTie,
  FaUsers,
  FaWallet
} from 'react-icons/fa';

export const ROLE_LABELS = {
  admin: 'Administrador',
  cliente: 'Cliente',
  asesor: 'Asesor',
  auditor: 'Auditor',
  cajero: 'Cajero',
  operaciones: 'Operaciones',
  contabilidad: 'Contabilidad'
};

export const roleNavigation = {
  admin: [
    { type: 'link', to: '/admin/home', label: 'INICIO', icon: FaHome },
    {
      type: 'group',
      id: 'admin_dashboards',
      label: 'DASHBOARDS',
      icon: FaChartPie,
      items: [
        { to: '/admin/dashboard', label: 'PRÉSTAMOS', icon: FaHandHoldingUsd },
        { to: '/admin/dashboard/renta', label: 'RENTA Y AMORTIZACIÓN', icon: FaChartLine }
      ]
    },
    { type: 'link', to: '/admin/calculadora', label: 'REGISTRO DE CRÉDITOS', icon: FaCalculator },
    { type: 'link', to: '/admin/productos', label: 'PRODUCTOS', icon: FaBoxOpen },
    {
      type: 'group',
      id: 'admin_clientes',
      label: 'GESTIÓN DE CLIENTES',
      icon: FaUsers,
      items: [
        { to: '/admin/clientes', label: 'REGISTRO DE CLIENTES', icon: FaUserPlus },
        { to: '/admin/asignar-avales', label: 'ASIGNACIÓN DE AVAL', icon: FaUserShield }
      ]
    },
    { type: 'link', to: '/admin/asesores', label: 'GESTIÓN DE EMPLEADOS', icon: FaUserTie },
    {
      type: 'group',
      id: 'admin_pagos',
      label: 'GESTIÓN DE PAGOS',
      icon: FaMoneyBillAlt,
      items: [
        { to: '/admin/estados', label: 'REGISTRO DE CUOTAS', icon: FaChartBar },
        { to: '/admin/pagos/filtros', label: 'FILTRAR PAGOS', icon: FaFilter }
      ]
    },
    { type: 'link', to: '/admin/gestion-cartera', label: 'GESTIÓN DE CARTERA', icon: FaExchangeAlt },
    { type: 'link', to: '/admin/gestion-moras', label: 'GESTIÓN DE MORAS', icon: FaHistory },
    { type: 'link', to: '/admin/historial-prestamos', label: 'HISTORIAL PRÉSTAMOS', icon: FaClipboardList },
    { type: 'link', to: '/admin/cronograma', label: 'CRONOGRAMAS', icon: FaCalendarAlt },
    {
      type: 'group',
      id: 'admin_reportes',
      label: 'REPORTES',
      icon: FaChartLine,
      items: [
        { to: '/admin/prestamos-activos', label: 'SEGUIMIENTO', icon: FaChartBar },
        { to: '/admin/clientes-sin-prestamo', label: 'SIN PRÉSTAMO', icon: FaChartBar },
        { to: '/admin/finanzas', label: 'FINANZAS', icon: FaChartLine }
      ]
    },
    {
      type: 'group',
      id: 'admin_egresos_ingresos',
      label: 'EGRESOS / INGRESOS',
      icon: FaWallet,
      items: [
        { to: '/admin/egresos', label: 'EGRESOS', icon: FaMoneyBillAlt },
        { to: '/admin/ingresos', label: 'INGRESOS', icon: FaMoneyBillAlt }
      ]
    }
  ],
  cliente: [
    { type: 'link', to: '/cliente/estados', label: 'PAGAR CUOTAS', icon: FaChartBar },
    { type: 'link', to: '/cliente/mispagos', label: 'MIS PAGOS', icon: FaWallet }
  ],
  asesor: [
    {
      type: 'group',
      id: 'asesor_clientes',
      label: 'GESTIÓN DE CLIENTES',
      icon: FaUsers,
      items: [{ to: '/asesor/home', label: 'REGISTRO DE CLIENTES', icon: FaUserPlus }]
    },
    {
      type: 'group',
      id: 'asesor_pagos',
      label: 'GESTIÓN DE PAGOS',
      icon: FaMoneyBillAlt,
      items: [
        { to: '/asesor/cuotas-pendientes', label: 'CUOTAS PENDIENTES', icon: FaCalendarAlt }
      ]
    },
    { type: 'link', to: '/asesor/gestion-moras', label: 'GESTIÓN DE MORAS', icon: FaHistory },
    { type: 'link', to: '/asesor/mis-desembolsos', label: 'MIS DESEMBOLSOS', icon: FaMoneyBillWave }
  ],
  auditor: [
    {
      type: 'group',
      id: 'auditor_pagos',
      label: 'GESTIÓN DE PAGOS',
      icon: FaMoneyBillAlt,
      items: [{ to: '/auditor/home', label: 'FILTRAR PAGOS', icon: FaFilter }]
    },
    { type: 'link', to: '/auditor/historial-prestamos', label: 'HISTORIAL PRÉSTAMOS', icon: FaClipboardList },
    { type: 'link', to: '/auditor/cronograma', label: 'CRONOGRAMAS', icon: FaCalendarAlt }
  ],
  cajero: [
    { type: 'link', to: '/cajero/estados', label: 'REGISTRO DE CUOTAS', icon: FaMoneyBillAlt },
    { type: 'link', to: '/cajero/caja', label: 'CAJA', icon: FaWallet }
  ],
  operaciones: [
    { type: 'link', to: '/operaciones/calculadora', label: 'REGISTRO DE CRÉDITOS', icon: FaCalculator },
    { type: 'link', to: '/operaciones/cronograma', label: 'CRONOGRAMAS', icon: FaCalendarAlt },
    { type: 'link', to: '/operaciones/clientes', label: 'REGISTRO DE CLIENTES', icon: FaUserPlus },
  ],
  contabilidad: [
    { type: 'link', to: '/contabilidad/finanzas', label: 'FINANZAS', icon: FaChartLine },
    { type: 'link', to: '/contabilidad/egresos', label: 'EGRESOS', icon: FaMoneyBillAlt },
    { type: 'link', to: '/contabilidad/ingresos', label: 'INGRESOS', icon: FaMoneyBillAlt }
  ]
};